import type { EventType } from 'mitt'
import mitt from 'mitt'

/**
 * 基于 mitt 的事件分发器，提供 on/emit/off 基础能力。
 */
export default class EventDispatcher {
  private readonly emitter = mitt()

  /**
   * 订阅事件。
   *
   * @param type - 事件名称
   * @param handler - 事件触发时调用的回调
   */
  on(type: EventType, handler: (...args) => void) {
    this.emitter.on(type, handler)
  }

  /**
   * 触发事件。
   *
   * @param type - 事件名称
   * @param event - 透传给订阅者的事件数据
   */
  emit(type: EventType, event?: any) {
    this.emitter.emit(type, event)
  }

  /**
   * 取消订阅事件。
   *
   * @param type - 事件名称
   * @param handler - 需要移除的回调，省略时清除该事件的所有订阅
   */
  off(type: EventType, handler?: (...args) => void) {
    this.emitter.off(type, handler)
  }
}
